// store/slices/events.ts — rolling ring buffer of recent AdminEvents.
//
// Drives the live activity panel. Capped at MAX_EVENTS so the slice doesn't
// grow unbounded over a long admin session. Newest first.

import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AdminEvent } from "../types";

const MAX_EVENTS = 100;

interface EventsState {
  list: AdminEvent[];
}

const initialState: EventsState = { list: [] };

const events = createSlice({
  name: "events",
  initialState,
  reducers: {
    push(state, action: PayloadAction<AdminEvent>) {
      state.list.unshift(action.payload);
      if (state.list.length > MAX_EVENTS) {
        state.list.length = MAX_EVENTS;
      }
    },
    clear(state) {
      state.list = [];
    },
  },
});

export default events;
